import Dropdown from "./Dropdown";

export default class PdpDropdownModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title: this.props.data.DropDownName,
            originalIds: [],
            selectionCompleted: false,
            selectedPrice: 0,
            selectedId: 0
        };
        this.props.originalIds = [];
        this.handleSingleChange = this.handleSingleChange.bind(this);
        this.props.data.DropDownEntries.map((item) => {
            if (item.selected === "true") {
                this.state.title = item.label;
                this.state.selectionCompleted = true;
            }
            this.state.originalIds.push(item.value);
        });
    }
    handleSingleChange(item, originalIds) {
        let selectItem = {};
        selectItem.value = item.value;
        selectItem.label = item.label;
        selectItem.baseCal = item.BaseCalories;
        selectItem.componentDisplay = item.ComponentDisplay;
        selectItem.price = item.CalcPrice;
        selectItem.order = 2;
        selectItem.parentModifierId = this.props.parentModifierId || this.props.id || 0;
        selectItem.parentGroupId = this.props.parentID || this.props.id;
        selectItem.parentOptionGroupId = this.props.parentID || this.props.selectedoptionGroupId || this.props.parentModifierId || this.props.id || 0;
        //console.log(selectItem);
        let arr;
        if (this.props.fromModal == true) {
            arr = JSON.parse(JSON.stringify(this.props.getlocalMultiSelectIds()));
            if (arr.indexOf(this.state.selectedId) > -1) {
                //console.log("Remove the Previous selected dropdown amount -----> " + this.state.selectedPrice);
                arr.splice(arr.indexOf(this.state.selectedId), 1);
            }
            if (this.props.isSteakTempComp != true) {
                arr.push(item.value);
                this.props.setlocalMultiSelectIds(arr);
            } else {
                this.props.setSelectedModifiersList(selectItem);
                arr.push(item.value);
                this.props.setlocalMultiSelectIds(arr);

            }
            
        }

        this.state.selectedPrice = item.Price;
        this.state.selectedId = item.value;

        this.props.holdTempSelectedIds('single', selectItem, originalIds);

    }

    render() {
        const { title, originalIds, selectionCompleted } = this.state
        return (
            <div className="maxOneDropdown Option App" data-group-name={this.props.data.DropDownName}>
                <Dropdown items={this.props.data.DropDownEntries} title={title} selectionCompleted={selectionCompleted}
                    handleSelectBox={(item) => this.handleSingleChange(item, originalIds)}
                    id={this.props.Id} reqdStatus={this.props.reqdStatus} selectedModifiers={this.props.selectedModifiers} />
            </div>
        );
    }
}
